//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"EndCaps",1,0],[1,"FalloffDistance",0,"Expression",0],[1,"GraphStructure",0,"ScCollector",0],[1,"NodeSize",0,"Expression",0],[0,"Resolution",1,0],[1,"RodSize",0,"Expression",0]],[],[]];
SPLM.Features.TubeLatticeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TubeLatticeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TubeLatticeBuilder.EndCapsType = Object.freeze({
    "None" : "None", "Flat" : "Flat", "Round" : "Round"});

SPLM.Features.TubeLatticeBuilder.ResolutionType = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine"});

export default SPLM;